import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ModalContainer = styled.div`
  z-index: 2147483647;
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background: rgb(36, 54, 70);
  opacity: 0.9;
`

const ModalContents = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  @include oe-border-radius(10px);
  animation: fade-in-modal;
  animation-duration: 0.5s;
  overflow: hidden;
  background: transparent;
`

// This component is based on the Modal in Quest! Web
export default class Modal extends React.Component {
  constructor(props) {
    super(props)
    this.onEscapeBound = this.onEscape.bind(this)
  }

  componentDidMount() {
    if (this.props.lockBodyScroll) {
      document.body.classList.add('no-scroll')
    }

    document.addEventListener('keyup', this.onEscapeBound)
  }

  componentWillUnmount() {
    if (this.props.lockBodyScroll) {
      document.body.classList.remove('no-scroll')
    }

    document.removeEventListener('keyup', this.onEscapeBound)
  }

  onEscape(e) {
    // ESC key
    if (e.keyCode === 27 && this.props.allowEscape) {
      this.props.closeCallback()
    }
  }

  render() {
    // TODO: change this to accept % height (and probably width too)
    const style = {
      height: !this.props.autoHeight
        ? this.props.percentHeight
          ? `${this.props.percentHeight}%`
          : `${this.props.height}px`
        : 'auto',
      width: `${this.props.width}px`,
      transform: 'translate(-50%, -50%)'
    }

    const overlayStyle = {}

    if (this.props.background) {
      overlayStyle.background = this.props.background
    }

    if (this.props.opacity) {
      overlayStyle.opacity = this.props.opacity
    }

    if (this.props.allowOverflow) {
      style.overflow = 'visible'
    }

    if (this.props.allowInnerScroll) {
      style.overflowY = 'scroll'
    }

    if (this.props.maxPercentHeight) {
      delete style.height
      style.maxHeight = `${this.props.maxPercentHeight}%`
    }

    if (this.props.top) {
      style.top = `${this.props.top}%`
    }

    if (this.props.borderRadius) {
      style.borderRadius = `${this.props.borderRadius}`
    }

    if (this.props.boxShadow) {
      style.boxShadow = `${this.props.boxShadow}`
    }

    return (
      <ModalContainer>
        <ModalOverlay
          style={overlayStyle}
          onClick={
            this.props.allowCloseOnExternalClick
              ? this.props.closeCallback
              : null
          }
        />
        <ModalContents
          onClick={(e) => e.target.className.includes('ModalContents') &&
            this.props.closeCallback()}
          style={style}>
          {this.props.children}
        </ModalContents>
      </ModalContainer>
    )
  }
}

Modal.defaultProps = {
  allowEscape: true,
  allowCloseOnExternalClick: true,
  lockBodyScroll: true,
  autoHeight: false,
  allowInnerScroll: false,
  allowOverflow: false
}

Modal.propTypes = {
  top: PropTypes.number,
  percentHeight: PropTypes.number,
  maxPercentHeight: PropTypes.number,
  autoHeight: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  background: PropTypes.string,
  opacity: PropTypes.string,
  borderRadius: PropTypes.string,
  boxShadow: PropTypes.string,
  children: PropTypes.object,
  closeCallback: PropTypes.func,
  allowEscape: PropTypes.bool,
  lockBodyScroll: PropTypes.bool,
  allowInnerScroll: PropTypes.bool,
  allowCloseOnExternalClick: PropTypes.bool,
  allowOverflow: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/mini/Modal.js